const styles = theme => ({
  cancelModal: {
    padding: '24px',
    [theme.breakpoints.up('md')]: {
      width: '420px',
    },
  },
  dialogTitle: {
    marginBottom: '0px',
    '$ :after': {
      background: 'none',
    },
  },
  cancelModalContainer: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '-12px',
      top: '1px',
    },
    '& h1': {
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      color: '#342D3D',
      fontSize: '16px',
      fontWeight: '500',
    },
    '& hr': {
      backgroundColor: '#CED1D6',
    },
  },
  primaryBtn: {
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '70%',
    },
  },
  secondaryBtn: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '30%',
    },
  },
  '@media (min-width: 768px)': {
    Title: {
      fontSize: '24px',
    },
    subTitle: {
      fontSize: '18px',
    },
  },
  modalBtnholder: {
    textAlign: 'left',
    display: 'flex',
    '& button': {
      margin: '5px',
    },
    '& $primaryBtn': {
      background: theme.palette.primary.main,
      color: '#fff',
      padding: '12px 24px',
      borderRadius: '4px',
      textTransform: 'initial',
      [theme.breakpoints.down('sm')]: {
        padding: '8px 10px',
      },
    },
    '& $secondaryBtn': {
      borderRadius: '4px',
      textTransform: 'initial',
      padding: '12px 24px',
      border: '1px solid black',
      [theme.breakpoints.down('sm')]: {
        padding: '8px 10px',
      },
    },
  },
  cancelModalHeader: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  closeIcon: {
    cursor: 'pointer',
  },
});

export default styles;
